import { useState, useEffect } from 'react';

const usePaginate = (data) => {
  const [pagination, setPagination] = useState({
    offset: 0,
    numberPerPage: 16,
    pageCount: 0,
    currentData: []
  });
  useEffect(() => {
    data && setPagination((prevState) => ({
      ...prevState,
      pageCount: data?.length / prevState.numberPerPage,
      currentData: data?.slice(pagination.offset, pagination.offset + pagination.numberPerPage)
    }))
  }, [pagination.numberPerPage, pagination.offset, data])

  const handlePageClick = event => {
    const selected = event.selected;
    const offset = selected * pagination.numberPerPage
    setPagination({ ...pagination, offset })
  }

  return { handlePageClick, pagination }
}

export { usePaginate };
